module.exports = __webpack_public_path__ + "static/media/4 realistic feather wings eagle hawk 2.1280x1707.f5d36232.webp";